module.exports = __webpack_public_path__ + "img/cabinet_fault.d627c8a9.svg";